Hop.defineModule('print', (root, {iframe = false}) => {
    const $root = $(root);

    if (iframe && !document.getElementById('printiframe')) {
        $('body').append('<iframe id="printiframe" name="printiframe" class="hide" src="" ></iframe>');
    }

    const $printiframe = $('#printiframe');

    function printIframe($target) {
        const url = $target.attr('data-urlprint');
        // print pdf by iframe doesn't work width firefox & safari css bug
        const browser = Hop.getBrowserDesc();
        if (browser.firefox || browser.safari) {
            window.open($target.data('urlprint'));
        } else {
            $printiframe.attr('src', url);

            $printiframe.load(function () {
                try {
                    // eslint-disable-next-line no-invalid-this
                    this.contentWindow.print();
                } catch (err) {
                    window.open($target.data('urlprint'));
                }
            });
        }
    }

    $root.on('click', '[data-print-cta]', (e) => {
        e.preventDefault();
        if (iframe) {
            printIframe($(e.target));
        } else {
            $('body').addClass('print');
            print();
        }
    });
});
